import { render, staticRenderFns } from "./EzOnOff.vue?vue&type=template&id=6048fcca&scoped=true&"
import script from "./EzOnOff.vue?vue&type=script&lang=js&"
export * from "./EzOnOff.vue?vue&type=script&lang=js&"
import style0 from "./EzOnOff.vue?vue&type=style&index=0&id=6048fcca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048fcca",
  null
  
)

export default component.exports